<template>
  <div class="main main--login main--background">
    <img src="../../assets/img/geberit-logo-1.png" alt="geberit" class="login__logo login__logo--fixed">
    <nav class="login__nav">
      <router-link :to="{ name: 'AuthenticationLogin' }" class="login__nav-button">
        Zaloguj się
      </router-link>
      <router-link :to="{ name: 'AuthenticationRegister' }" class="login__nav-button">
        Zarejestruj się
      </router-link>
      <router-link :to="{ name: 'InvoicesAddAsGuest' }" class="login__nav-button">
        Dodaj dowód zakupu
      </router-link>
      <router-link :to="{ name: 'About' }" class="login__nav-button">
        O programie
      </router-link>
    </nav>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "WelcomeComponent",
};
</script>



// WEBPACK FOOTER //
// src/app/components/WelcomeComponent.vue